import React, { CSSProperties } from "react";

interface TextExportProps {
  text?: string | Record<string, string>;
  fontSize?: number;
  fontFamily?: string;
  fontWeight?: string;
  color?: string;
  textAlign?: "left" | "center" | "right";
  lineHeight?: number;
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  maxWidth?: string;
  tagName?: string;
  fontStyle?: string;
  whiteSpace?: string;
}

export const TextExport: React.FC<TextExportProps> = ({
  text = "Text",
  fontSize = 16,
  fontFamily,
  fontWeight = "normal",
  color = "#000000",
  textAlign = "left",
  lineHeight,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  maxWidth,
  tagName = "p",
  fontStyle,
  whiteSpace,
}) => {
  const isGradient = color.includes("gradient");

  const style: CSSProperties = {
    fontSize: `${fontSize}px`,
    ...(fontFamily
      ? { fontFamily: `'${fontFamily}', var(--font-family), sans-serif` }
      : typeof text === "string" && !/[\u0E00-\u0E7F]/.test(text)
        ? { fontFamily: "var(--font-family-en, var(--font-family))" }
        : typeof text === "object" && !/[\u0E00-\u0E7F]/.test((text as Record<string, string>).th || "")
          ? { fontFamily: "var(--font-family-en, var(--font-family))" }
          : {}),
    fontWeight: fontWeight as CSSProperties["fontWeight"],
    ...(isGradient
      ? {
          background: color,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          ...(fontStyle === "italic" ? { paddingRight: "4px" } : {}),
        }
      : { color }),
    textAlign: textAlign as CSSProperties["textAlign"],
    lineHeight: lineHeight || 1.6,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    marginLeft: `${marginLeft}px`,
    marginRight: `${marginRight}px`,
    maxWidth: maxWidth || "none",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    ...(fontStyle ? { fontStyle: fontStyle as CSSProperties["fontStyle"] } : {}),
    ...(whiteSpace ? { whiteSpace: whiteSpace as CSSProperties["whiteSpace"] } : {}),
  };

  const Tag = tagName as React.ElementType;

  if (typeof text === "object") {
    const obj = text as Record<string, string>;
    const displayText = obj.th || obj.en || "";
    return (
      <div style={{ width: "100%" }}>
        <Tag style={style} data-i18n-th={obj.th || ""} data-i18n-en={obj.en || ""} className="i18n-text">{displayText}</Tag>
      </div>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <Tag style={style}>{text}</Tag>
    </div>
  );
};
